const fontSizes = {
  '2xl': '1.5rem',
  '3xs': '0.5rem',
  '4xl': '2rem',
  '5xl': '2.5rem',
  '6xl': '3rem',
  '7xl': '4rem',
  '8xl': '4.5rem',
  '9xl': '6rem',
  lg: '1.125rem',
  md: '1rem',
  sm: '0.875rem',
  xl: '1.25rem',
  xs: '0.75rem',
  xxs: '0.625rem',
}

export { fontSizes }
